import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import SubscriptionAdd from "../../components/SubscriptionPlan/AddSubscriptionPlan";


const SubscriptionAddPage = () => {
  return (
    <>
    
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Subscription  </h5><Breadcrumb title="Add Subscription" /></div>


        {/* AddUserLayer */}
        <SubscriptionAdd />


    </>
  );
};

export default SubscriptionAddPage;